import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { ConditionOutcome } from 'components/powerFlowShared/components/types';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { AutomationNodeTypes } from 'hocs';
import { createConditionModalContainer } from '../../../containers/condition';
import { CONDITION_NODE_LABEL } from '../../constants';
import { MatchingStrategy } from '../types';
const translatePayload = (node) => {
    const { nonMatchNodeId, matchNodeId } = node.payload;
    return [
        {
            id: uuid(),
            label: ConditionOutcome.NO_MATCH,
            connection: nonMatchNodeId || uuid(),
        },
        {
            id: uuid(),
            label: ConditionOutcome.MATCH,
            connection: matchNodeId || uuid(),
        },
    ];
};
const updateConnection = (node, connection, connectionId) => {
    const key = connection.connectionLabel === ConditionOutcome.MATCH
        ? 'matchNodeId'
        : 'nonMatchNodeId';
    const payload = Object.assign(Object.assign({}, node.payload), { [key]: connectionId });
    return Object.assign(Object.assign({}, node), { payload });
};
const ConditionModal = createConditionModalContainer(AutomationNodeTypes.CONDITION, (node) => {
    if (node.nodeType === 'action') {
        return {
            matchNodeId: uuid(),
            nonMatchNodeId: uuid(),
            matchingStrategy: MatchingStrategy.ALL,
            rules: [],
        };
    }
    return node.payload;
});
export const ConditionNodeAttributes = {
    iconName: 'branch',
    label: CONDITION_NODE_LABEL,
    color: hexStringToNumber(flowNodeColor.purple),
    translatePayload,
    updateConnection,
    NodeContent: ConditionNode,
    ActionModal: ConditionModal,
};
export function ConditionNode({ node }) {
    const { payload } = node;
    const { rules } = payload;
    return (_jsx(TextContent, { children: useMemo(() => (_jsx(TextEllipsis, { children: _jsx(Text, { weight: "semibold", text: `${rules.length} ${rules.length === 1 ? 'rule' : 'rules'}` }) })), [rules]) }));
}
